import React from 'react';
import {
  IconFileText,
  IconTable,
  IconWifi,
  IconArrowRight,
  IconDatabase,
} from './ToolsIcons';
import CustomsEntryAnalyzer from '../../analyzers/CustomsEntryAnalyzer';
import AIReportBuilder from '../../reports/AIReportBuilder';
import Library from '../library/Library';
import './importTools.css';

type ToolKey = 'upload' | 'reports' | 'api' | 'library';

type Tool = {
  key: ToolKey;
  name: string;
  blurb: string;
  icon: (props: { className?: string }) => React.JSX.Element;
  disabled?: boolean;
};

const TOOLS: Tool[] = [
  {
    key: 'upload',
    name: 'Document Upload',
    blurb: 'Bring broker filings and source documents in for analysis',
    icon: IconFileText,
  },
  {
    key: 'reports',
    name: 'Reports',
    blurb: 'Build and review generated reports',
    icon: IconTable,
  },
  {
    key: 'library',
    name: 'Library',
    blurb: 'Browse every source document and generated output',
    icon: IconDatabase,
  },
  {
    key: 'api',
    name: 'API',
    blurb: 'Connect and pull data programmatically',
    icon: IconWifi,
    disabled: true,
  },
];

const ImportTools = (): React.JSX.Element => {
  const [active, setActive] = React.useState<ToolKey | null>(null);
  const activeTool = TOOLS.find((tool) => tool.key === active);

  if (activeTool) {
    const Icon = activeTool.icon;

    return (
      <div
        className={`iml-root iml-style-island iml-page is-${activeTool.key}`}
      >
        <div className='iml-page-bar'>
          <button
            type='button'
            className='iml-back'
            onClick={() => setActive(null)}
          >
            <IconArrowRight className='iml-back-icon' />
            Back to tools
          </button>
          <div className='iml-page-title'>
            <div className='iml-row-icon'>
              <Icon className='iml-icon' />
            </div>
            {activeTool.name}
          </div>
        </div>

        <div className='iml-page-body'>
          {(activeTool.key === 'upload' || activeTool.key === 'reports') && (
            <div className='iml-embedded-workflow'>
              {activeTool.key === 'upload' && <CustomsEntryAnalyzer embedded />}
              {activeTool.key === 'reports' && <AIReportBuilder embedded />}
            </div>
          )}
          {activeTool.key === 'api' && (
            <div className='iml-panel-placeholder'>
              {activeTool.name} will live here
            </div>
          )}
          {activeTool.key === 'library' && (
            <div className='iml-library-surface'>
              <Library />
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className='iml-root iml-style-island'>
      <div className='iml-shelf'>
        {TOOLS.map((tool) => {
          const Icon = tool.icon;

          return (
            <div
              key={tool.key}
              className={`iml-row is-${tool.key}${
                tool.disabled ? ' is-disabled' : ''
              }`}
            >
              <button
                type='button'
                className='iml-row-head'
                disabled={tool.disabled}
                onClick={() => setActive(tool.key)}
              >
                <div className='iml-row-icon'>
                  <Icon className='iml-icon' />
                </div>
                <div className='iml-row-text'>
                  <div className='iml-row-title'>
                    <div className='iml-row-name'>{tool.name}</div>
                    {tool.disabled && (
                      <span className='iml-coming-soon'>COMING SOON</span>
                    )}
                  </div>
                  <div className='iml-row-blurb'>{tool.blurb}</div>
                </div>
                {!tool.disabled && <IconArrowRight className='iml-row-arrow' />}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ImportTools;
